import {
  BaseFieldWidget,
  FormM2MTableFieldWidget,
  ModelFieldType,
  SPI,
  SubmitValue,
  ViewType
} from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    model: 'deli.aries.item.DeliAriesItemManifestProxy',
    name: 'deliAriesItemList',
    viewType: ViewType.Form,
    ttype: ModelFieldType.ManyToMany,
    widget:'Table'
  })
)
export class reloadFiledSubmitWidget extends FormM2MTableFieldWidget {
  public async submit(submitValue: SubmitValue) {
    const childWidget = this.getChildrenWidget()[0].getChildrenWidget()[2];
    if (childWidget && 'dataSource' in childWidget) {
      return { [this.itemName]: (childWidget as any).dataSource };
    }
    return { [this.itemName]: [] };
  }
}
